import { Product } from "../../types/Product";
import { ProductVariant } from "../../types/ProductVariant";
import { formatMoney } from "../../styles/liquidGlass";

interface ProductBasicInfoProps {
  product: Product;
  variant?: ProductVariant | null;
}

export default function ProductBasicInfo({ product, variant }: ProductBasicInfoProps) {
  const displayPrice = variant ? variant.precio : product.precio;

  return (
    <div>
      <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
        <span className="pill" style={{ padding: "6px 12px", fontSize: 11, letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 600 }}>
          Nuevo
        </span>
        <span className="pill" style={{ padding: "6px 12px", fontSize: 11, letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 500, color: "var(--ink-500)" }}>
          SKU {variant?.SKU || product.sku}
        </span>
      </div>

      <h1
        style={{
          fontSize: 44,
          lineHeight: 1,
          margin: 0,
          fontWeight: 500,
          letterSpacing: "-0.035em",
        }}
      >
        {product.nombre}
      </h1>

      <div style={{ marginTop: 22, display: "flex", alignItems: "baseline", gap: 12, flexWrap: "wrap" }}>
        <span className="mono" style={{ fontSize: 38, fontWeight: 600, letterSpacing: "-0.025em" }}>
          {formatMoney(displayPrice)}
        </span>
        <span style={{ fontSize: 14, color: "var(--ink-500)" }}>· precio mayorista x unidad</span>
      </div>
    </div>
  );
}
